import { connect } from 'react-redux';

import {
  IComplaintFeedbackBody,
  ComplaintFeedbackForm,
  IComplaintFeedbackFormStoreProps,
  IComplaintFeedbackFormDispatchProps,
  IComplaintFeedbackFormOwnProps,
} from './';
import { sendFeedbackComplaint, statusChanger, EFeedbackComplaint } from '../../../store/complaint/feedback_complaint';

import type { DispatchReduxAction, IState } from '../../../store';

export function mapStateToProps(state: IState) {
  /* istanbul ignore next */
  const { complaintId, status } = state.complaintFeedbackFrom;
  /* istanbul ignore next */
  const { user } = state.offerData;
  /* istanbul ignore next */
  const { getUserFeedback, prefilledEmail } = state.complaint;

  /* istanbul ignore next */
  let userEmail;

  if (user && user.isAuthenticated && user.email) {
    userEmail = user.email;
  }

  if (prefilledEmail) {
    userEmail = prefilledEmail;
  }

  return {
    complaintId,
    sendFormStatus: status,
    userEmail,
    getUserFeedback,
  };
}

/* istanbul ignore next */
export function mapDispatchToProps(dispatch: DispatchReduxAction) {
  return {
    sendComplaintFeedback: (body: IComplaintFeedbackBody) => dispatch(sendFeedbackComplaint(body)),
    statusChanger: (status: EFeedbackComplaint) => dispatch(statusChanger(status)),
  };
}

export const ComplaintFeedbackFormContainer = connect<
  IComplaintFeedbackFormStoreProps,
  IComplaintFeedbackFormDispatchProps,
  IComplaintFeedbackFormOwnProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(ComplaintFeedbackForm);
